const TEST_APP_BASE_URL = "https://test.lifelog.care";
const PROD_APP_BASE_URL = "https://lifelog.care";

const normalizeBaseUrl = (value = "") => String(value || "").trim().replace(/\/+$/, "");

export const resolveInvitationBaseUrl = ({
  locationRef = typeof window !== "undefined" ? window.location : null,
  appEnv = process.env.REACT_APP_APP_ENV,
  configuredBaseUrl = process.env.REACT_APP_PUBLIC_APP_URL,
} = {}) => {
  const configured = normalizeBaseUrl(configuredBaseUrl);
  if (configured) return configured;

  const hostname = String(locationRef?.hostname || "").toLowerCase();
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  if (isLocal) {
    return appEnv === "prod" ? PROD_APP_BASE_URL : TEST_APP_BASE_URL;
  }

  return normalizeBaseUrl(locationRef?.origin)
    || (appEnv === "prod" ? PROD_APP_BASE_URL : TEST_APP_BASE_URL);
};

export const buildInvitationLink = (invitationId, options = {}) => {
  const cleanInvitationId = String(invitationId || "").trim();
  const encodedId = encodeURIComponent(cleanInvitationId);
  return `${resolveInvitationBaseUrl(options)}/accept-invite?token=${encodedId}&invitationId=${encodedId}`;
};
